import React, { useRef } from "react";
import useAuthority from "../../hooks/useAuthority";
import { AUTH_TYPES, AUTHORITY_TYPE } from "../../const";
import { AlertCircle } from "react-feather";
import Modal from "../Modal";
import Button from "../input/Button";

const DeleteButtonRenderer = ({
  clickHandler,
  params,
  label = "Delete",
  className = "ui red button",
  message = "Are you sure you want to delete this record?",
  modalTitle = "Warning",
  disabled = false,
  editMode = false,
  authType = AUTHORITY_TYPE.FORM,
  needDeletePermission = false,
  form = "-",
  field = "-",
  module = "-",
  authenticated = false,
  consider = AUTH_TYPES.VIEW,
  style = null,
}) => {
  const modalRef = useRef();

  const { view, authorized, deletePermission } = useAuthority({
    type: authType,
    module,
    field,
    form,
    editMode,
    authenticated,
    needDeletePermission,
  });

  const isDisabled =
    disabled ||
    (consider === AUTH_TYPES.VIEW
      ? !view
      : consider === AUTH_TYPES.DELETE
        ? editMode
          ? !deletePermission
          : !authorized
        : !authorized);

  return (
    <>
      <button
        type="button"
        className={className}
        style={style ?? {}}
        disabled={isDisabled}
        onClick={() => modalRef.current?.showModal()}
      >
        {label}
      </button>

      <Modal ref={modalRef} closeButton={false} minWidth="300px">
        <div style={{ padding: "20px" }}>
          <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <AlertCircle color="red" size={25} />
            <p style={{ margin: 0 }}>{modalTitle}</p>
          </h3>

          <p style={{ margin: "12px 0 20px" }}>{message}</p>

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "flex-end",
            }}
          >
            <Button label="Cancel" onClick={() => modalRef.current?.close()} />
            <Button
              label="Proceed"
              className="ui red button"
              onClick={() => {
                modalRef.current?.close();
                clickHandler?.();
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteButtonRenderer;
